import React from "react";
import CloseButton from "./CloseButton";
import DashboardCollapse from "./DashboardCollapse";

export default function ProductListResults(props) {

    const { closeFilterLabel,
        filterSectionComponent,
        productListGridComponent,
        isLoading,
        activeDashboardCollapse,
        handleDashboardCollapse } = props;

    return (
        <div className="product-list-results">
            {
                !isLoading ?
                    <DashboardCollapse className="product-filters product-filters--alt" id="product-filters"
                        activeDashboardCollapse={activeDashboardCollapse}>
                        <div className="product-filters-actions">
                            <CloseButton
                                closeDashboardToggleId="#product-filters"
                                handleDashboardCollapse={handleDashboardCollapse}
                                closeText={closeFilterLabel} />
                        </div>
                        {filterSectionComponent}
                    </DashboardCollapse>
                    :
                    null
            }
            {productListGridComponent}
        </div>
    );
}


